import React from 'react';

/**
 * CookiesPage component
 * Cookie Policy page for the healthcare AI platform
 */
const CookiesPage = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="py-20" style={{
        background: `linear-gradient(to top, #FFC000 0%, #FFFFFF 3%, #FFFFFF 97%, #FFC000 100%)`
      }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900">
              Cookie <span style={{ color: '#FFC000' }}>Policy</span>
            </h1>
            
            <p className="text-xl md:text-2xl mb-8 text-gray-700">
              How we use cookies and similar technologies on our platform.
            </p>
            
            <p className="text-gray-600">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </section>

      {/* Cookie Policy Content */}
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg dark:prose-invert">
            
            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">What Are Cookies</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Cookies are small text files that are stored on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and improving platform functionality.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Types of Cookies We Use</h2>
            
            <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Essential Cookies</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              These cookies are necessary for the platform to function properly and cannot be disabled:
            </p>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 mb-6 space-y-2">
              <li>Authentication and session management</li>
              <li>Security and fraud prevention</li>
              <li>Platform functionality and performance</li>
            </ul>

            <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Performance Cookies</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              These cookies help us understand how users interact with our platform:
            </p>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 mb-6 space-y-2">
              <li>Analytics and usage statistics</li>
              <li>Performance monitoring</li>
              <li>Error tracking and debugging</li>
            </ul>

            <h3 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Functional Cookies</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              These cookies enable enhanced functionality and personalization:
            </p>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 mb-6 space-y-2">
              <li>User preferences and settings</li>
              <li>Language and region preferences</li>
              <li>Theme and display preferences</li>
            </ul>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Third-Party Cookies</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              We may use third-party services that set their own cookies. These include analytics providers, security services, and integration partners. We ensure all third-party providers comply with healthcare data protection requirements.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Managing Cookies</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-4">
              You can control cookie settings through your browser preferences:
            </p>
            <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 mb-6 space-y-2">
              <li>Block all cookies (may affect platform functionality)</li>
              <li>Block third-party cookies only</li>
              <li>Delete existing cookies</li>
              <li>Set alerts when cookies are being sent</li>
            </ul>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Healthcare Data Protection</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              All cookies and tracking technologies used on our platform comply with HIPAA and other healthcare privacy regulations. We do not use cookies to store or transmit protected health information (PHI).
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Cookie Retention</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Session cookies are deleted when you close your browser. Persistent cookies remain on your device for a specified period or until you delete them. We regularly review and clean up unnecessary cookies.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Updates to This Policy</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              We may update this Cookie Policy periodically. When we make changes, we will update the "Last updated" date and notify users through the platform or email.
            </p>

            <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">Contact Us</h2>
            <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg">
              <p className="text-gray-600 dark:text-gray-300">
                If you have questions about our use of cookies, please contact us:<br />
                <strong>Email:</strong> privacy@videxa.com<br />
                <strong>Phone:</strong> 1-888-465-4246<br />
                <strong>Address:</strong> 123 Healthcare Innovation Drive, San Francisco, CA 94105
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiesPage;